/**
 * Numbers a list's loads so only the newest one's reply is applied. Without it a slow reply
 * to an earlier search or page can land after a later one and replace its rows.
 *
 *   const latest = createLatestRequest();
 *   const ticket = latest.next();
 *   send(reply => { if (!latest.isLatest(ticket)) return; ... });
 */
export function createLatestRequest() {
  let latest = 0;
  return {
    next() {
      latest += 1;
      return latest;
    },
    isLatest(ticket) {
      return ticket === latest;
    },
  };
}

export default createLatestRequest;
